import React, { useState } from "react";
import ProductsNavRow from "../rownavigator";

const ConstructionChemical = () => {
    // State management
    const [activeSubcategory, setActiveSubcategory] = useState(null);
    const [activeOption, setActiveOption] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Data structure
    const accessories = {
        name: "Accessories",
        subcategories: {
            iron_mongery_hardwares: {
                name: "Iron Mongery and Hardwares",
                options: {
                    door_locks: {
                        name: "Door Locks",
                        options: {
                            mortise_locks: {
                                name: "Mortise Locks",
                                images: ["/assets/doorlocks/antene.jpg"],
                                products: [
                                    {
                                        name: "Mortise Lock Antene",
                                        image: "/assets/doorlocks/antene.jpg",
                                        use: "Standard mortise door lock",
                                        details: "Durable and secure mortise lock",
                                        price: "",
                                    },
                                    {
                                        name: "Mortise Lock Polaris",
                                        image: "/assets/doorlocks/antpolaris.png",
                                        use: "Mortise installation",
                                        details: "High-strength lock for heavy doors",
                                        price: "",
                                    },
                                    {
                                        name: "Centro Mortise Lock",
                                        image: "/assets/doorlocks/centro.jpg",
                                        use: "Mortise door fitting",
                                        details: "Smooth and durable mechanism",
                                        price: "",
                                    },
                                    {
                                        name: "Focus Mortise Lock",
                                        image: "/assets/doorlocks/cntrofocus.png",
                                        use: "Mortise locking system",
                                        details: "Precision crafted mortise lock",
                                        price: "",
                                    },
                                    {
                                        name: "Mediana Mortise Lock",
                                        image: "/assets/doorlocks/mediana.png",
                                        use: "General door mortise lock",
                                        details: "Reliable everyday lock",
                                        price: "",
                                    },
                                    {
                                        name: "Mod701 Mortise Lock",
                                        image: "/assets/doorlocks/mod701.png",
                                        use: "Modern mortise lock",
                                        details: "Designed for strong security",
                                        price: "",
                                    },
                                    {
                                        name: "Patent Grande Lock",
                                        image: "/assets/doorlocks/patentgrande.jpg",
                                        use: "Large patent lock",
                                        details: "Strong steel design",
                                        price: "",
                                    },
                                    {
                                        name: "Patent Piccola Lock",
                                        image: "/assets/doorlocks/patentpiccola.jpg",
                                        use: "Small patent mortise lock",
                                        details: "Compact durable design",
                                        price: "",
                                    },
                                    {
                                        name: "Revolution XT Lock",
                                        image: "/assets/doorlocks/revolutionxt.png",
                                        use: "Mortise lock upgrade",
                                        details: "Advanced locking system",
                                        price: "",
                                    },
                                    {
                                        name: "Sicurezza Lock",
                                        image: "/assets/doorlocks/sicurezza.jpg",
                                        use: "Heavy-duty mortise lock",
                                        details: "Enhanced security system",
                                        price: "",
                                    },
                                    {
                                        name: "Sicurezza Lock 2",
                                        image: "/assets/doorlocks/sicurezza2.jpg",
                                        use: "Secure mortise fitting",
                                        details: "Durable and reliable",
                                        price: "",
                                    },
                                    {
                                        name: "Sicurezza Small Lock",
                                        image: "/assets/doorlocks/sicurezzas.jpg",
                                        use: "Compact mortise lock",
                                        details: "Strong and functional",
                                        price: "",
                                    },
                                ],
                            },
                            euro_profile: {
                                name: "Euro Profile Locks",
                                images: ["/assets/doorlocks/euro72.jpg"],
                                products: [
                                    {
                                        name: "Euro Profile Lock 72",
                                        image: "/assets/doorlocks/euro72.jpg",
                                        use: "Euro-profile cylinder doors",
                                        details: "Standard 72mm euro profile lock",
                                        price: "",
                                    },
                                ],
                            },
                            sliding_door_locks: {
                                name: "Sliding Door Locks",
                                images: [
                                    "/assets/doorlocks/scivola.png",
                                    "/assets/doorlocks/scivolas.png",
                                    "/assets/doorlocks/scivolas2.png",
                                ],
                                products: [
                                    {
                                        name: "Scivola Sliding Door Lock",
                                        image: "/assets/doorlocks/scivola.png",
                                        use: "Sliding doors",
                                        details: "Smooth sliding lock system",
                                        price: "",
                                    },
                                    {
                                        name: "Scivola-S Sliding Lock",
                                        image: "/assets/doorlocks/scivolas.png",
                                        use: "Sliding door installation",
                                        details: "Compact sliding lock",
                                        price: "",
                                    },
                                    {
                                        name: "Scivola-S2 Sliding Lock",
                                        image: "/assets/doorlocks/scivolas2.png",
                                        use: "Sliding door fitting",
                                        details: "Durable sliding lock system",
                                        price: "",
                                    },
                                ],
                            },
                            magnetic_locks: {
                                name: "Magnetic & Touch Locks",
                                images: [
                                    "/assets/doorlocks/duetto.png",
                                    "/assets/doorlocks/touchclose.jpg",
                                    "/assets/doorlocks/touchlock.png",
                                    "/assets/doorlocks/vitra.png",
                                    "/assets/doorlocks/wavelock.jpg",
                                    "/assets/doorlocks/waves.jpg",
                                ],
                                products: [
                                    {
                                        name: "Duetto Magnetic Lock",
                                        image: "/assets/doorlocks/duetto.png",
                                        use: "Modern magnetic locking",
                                        details: "Silent and smooth magnetic lock",
                                        price: "",
                                    },
                                    {
                                        name: "Touch Close Lock",
                                        image: "/assets/doorlocks/touchclose.jpg",
                                        use: "Touch-based closing system",
                                        details: "Push-to-close mechanism",
                                        price: "",
                                    },
                                    {
                                        name: "Touch Lock",
                                        image: "/assets/doorlocks/touchlock.png",
                                        use: "Touch-operated locking",
                                        details: "Innovative magnetic system",
                                        price: "",
                                    },
                                    {
                                        name: "Vitra Lock",
                                        image: "/assets/doorlocks/vitra.png",
                                        use: "Glass & modern doors",
                                        details: "Stylish lock with smooth finish",
                                        price: "",
                                    },
                                    {
                                        name: "Wave Lock",
                                        image: "/assets/doorlocks/wavelock.jpg",
                                        use: "Modern locking system",
                                        details: "Unique wave design lock",
                                        price: "",
                                    },
                                    {
                                        name: "Waves Lock",
                                        image: "/assets/doorlocks/waves.jpg",
                                        use: "Contemporary lock design",
                                        details: "Smooth finish, stylish",
                                        price: "",
                                    },
                                ],
                            },
                            catches_accessories: {
                                name: "Catches & Accessories",
                                images: [
                                    "/assets/doorlocks/duetocatches.png",
                                    "/assets/doorlocks/ovalcatches.png",
                                    "/assets/doorlocks/roundcates.png",
                                    "/assets/doorlocks/squarecatches.png",
                                    "/assets/doorlocks/modgancio.png",
                                    "/assets/doorlocks/kitventi.png",
                                ],
                                products: [
                                    {
                                        name: "Duetto Catch",
                                        image: "/assets/doorlocks/duetocatches.png",
                                        use: "Catch accessory",
                                        details: "Durable lock accessory",
                                        price: "",
                                    },
                                    {
                                        name: "Oval Catch",
                                        image: "/assets/doorlocks/ovalcatches.png",
                                        use: "Catch accessory",
                                        details: "Stainless oval design",
                                        price: "",
                                    },
                                    {
                                        name: "Round Catch",
                                        image: "/assets/doorlocks/roundcates.png",
                                        use: "Catch accessory",
                                        details: "Smooth round finish",
                                        price: "",
                                    },
                                    {
                                        name: "Square Catch",
                                        image: "/assets/doorlocks/squarecatches.png",
                                        use: "Catch accessory",
                                        details: "Square fitting",
                                        price: "",
                                    },
                                    {
                                        name: "Gancio Catch",
                                        image: "/assets/doorlocks/modgancio.png",
                                        use: "Hook-type accessory",
                                        details: "Durable accessory fitting",
                                        price: "",
                                    },
                                    {
                                        name: "Kitventi Cylinder",
                                        image: "/assets/doorlocks/kitventi.png",
                                        use: "Cylinder lock kit",
                                        details: "Compact and reliable",
                                        price: "",
                                    },
                                ],
                            },
                            general: {
                                name: "General Door Locks",
                                images: ["/assets/doorlocks/doorlocks.jpg"],
                                products: [
                                    {
                                        name: "General Door Lock",
                                        image: "/assets/doorlocks/doorlocks.jpg",
                                        use: "General purpose locking",
                                        details: "Standard durable door lock",
                                        price: "",
                                    },
                                ],
                            },
                        },
                    },

                    hinges: {
                        name: "Hinges",
                        options: {
                            concealed: {
                                name: "Concealed Hinges",
                                images: [
                                    "/assets/hinges/ku100.jpg",
                                    "/assets/hinges/ku1000.jpg",
                                    "/assets/hinges/ku6000.jpg",
                                    "/assets/hinges/ku9000.jpg",
                                ],
                                products: [
                                    {
                                        name: "KU 100 Concealed Hinge",
                                        image: "/assets/hinges/ku100.jpg",
                                        use: "Hidden hinge for doors",
                                        details: "Durable concealed hinge",
                                        price: "",
                                    },
                                    {
                                        name: "KU 1000 Concealed Hinge",
                                        image: "/assets/hinges/ku1000.jpg",
                                        use: "Heavy concealed doors",
                                        details: "Stainless concealed hinge",
                                        price: "",
                                    },
                                    {
                                        name: "KU 6000 Concealed Hinge",
                                        image: "/assets/hinges/ku6000.jpg",
                                        use: "High load concealed fitting",
                                        details: "Smooth concealed mechanism",
                                        price: "",
                                    },
                                    {
                                        name: "KU 9000 Concealed Hinge",
                                        image: "/assets/hinges/ku9000.jpg",
                                        use: "Advanced concealed doors",
                                        details: "Long lasting hinge",
                                        price: "",
                                    },
                                ],
                            },
                            pivot: {
                                name: "Pivot Hinges",
                                images: [
                                    "/assets/hinges/pivot.jpg",
                                    "/assets/hinges/pivots.jpg",
                                ],
                                products: [
                                    {
                                        name: "Pivot Hinge",
                                        image: "/assets/hinges/pivot.jpg",
                                        use: "Pivot doors",
                                        details: "Durable pivot hinge",
                                        price: "",
                                    },
                                    {
                                        name: "Pivot Hinge Small",
                                        image: "/assets/hinges/pivots.jpg",
                                        use: "Compact pivot installation",
                                        details: "Strong small hinge",
                                        price: "",
                                    },
                                ],
                            },
                            butt: {
                                name: "Butt Hinges",
                                images: ["/assets/hinges/butt.jpg"],
                                products: [
                                    {
                                        name: "Butt Hinge",
                                        image: "/assets/hinges/butt.jpg",
                                        use: "General door fitting",
                                        details: "Classic butt hinge",
                                        price: "",
                                    },
                                ],
                            },
                        },
                    },
                },
            },
        },
    };


    // Handlers
    const handleSubcategoryClick = (subcategoryKey) => {
        setActiveSubcategory(subcategoryKey);
        setActiveOption(null);
    };

    const handleOptionClick = (optionKey) => {
        setActiveOption(optionKey);
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    // Render subcategories
    const renderSubcategories = () => {
        if (!accessories?.subcategories) return null;

        return (
            <div className="mb-3">
                <h2 className="text-lg font-semibold mb-3">Subcategories</h2>
                <div className="flex flex-wrap gap-2">
                    {Object.entries(accessories.subcategories).map(
                        ([key, subcategory]) => (
                            <button
                                key={key}
                                className={`px-3 py-1 rounded-full text-sm ${activeSubcategory === key
                                    ? "bg-blue-500 text-white"
                                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                    }`}
                                onClick={() => handleSubcategoryClick(key)}
                            >
                                {subcategory?.name ?? "Unnamed Subcategory"}
                            </button>
                        )
                    )}
                </div>
            </div>
        );
    };

    // Render options
    const renderOptions = () => {
        if (!activeSubcategory) return null;

        const subcategory =
            accessories?.subcategories?.[activeSubcategory];
        if (!subcategory?.options) return null;

        return (
            <div className="mb-3">
                <h2 className="text-lg font-semibold mb-3">Options</h2>
                <div className="flex flex-wrap gap-2">
                    {Object.entries(subcategory.options).map(([key, option]) => (
                        <button
                            key={key}
                            className={`px-3 py-1 rounded-full text-sm ${activeOption === key
                                ? "bg-blue-500 text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                }`}
                            onClick={() => handleOptionClick(key)}
                        >
                            {option?.name ?? "Unnamed Option"}
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    // Render products
    const renderProducts = () => {
        let products = [];

        if (activeSubcategory && activeOption) {
            const option =
                accessories?.subcategories?.[activeSubcategory]?.options?.[
                activeOption
                ];
            if (option?.products) {
                products = option.products;
            } else if (option?.options) {
                const nestedOptionKey = Object.keys(option.options)[0];
                products = option?.options?.[nestedOptionKey]?.products ?? [];
            }
        } else if (
            activeSubcategory &&
            accessories?.subcategories?.[activeSubcategory]?.products
        ) {
            products =
                accessories?.subcategories?.[activeSubcategory]?.products ?? [];
        }

        if (!products || products.length === 0) {
            return (
                <div className="text-center py-10">
                    <p className="text-gray-500">
                        Select a subcategory and option to view products
                    </p>
                </div>
            );
        }

        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {products.map((product, index) => (
                    <div
                        key={index}
                        className="border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer"
                        onClick={() => handleProductClick(product)}
                    >
                        <div className="h-48 bg-gray-200 overflow-hidden">
                            <img
                                src={product?.image ?? "/placeholder.png"}
                                alt={product?.name ?? "Unnamed Product"}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="p-4">
                            <h3 className="font-semibold text-lg mb-2">
                                {product?.name ?? "Unnamed Product"}
                            </h3>
                            <p className="text-gray-600 mb-2">
                                {product?.use ?? "No use info"}
                            </p>
                            {/* <p className="text-blue-600 font-bold">
                                {product?.price || "Price not available"}
                            </p> */}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Modal
    const renderProductModal = () => {
        if (!isModalOpen || !selectedProduct) return null;

        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-2xl font-bold">
                                {selectedProduct?.name ?? "Unnamed Product"}
                            </h2>
                            <button
                                onClick={closeModal}
                                className="text-gray-500 hover:text-gray-700"
                            >
                                ✖
                            </button>
                        </div>

                        <div className="mb-4">
                            <img
                                src={selectedProduct?.image ?? "/placeholder.png"}
                                alt={selectedProduct?.name ?? "Unnamed Product"}
                                className="w-full h-64 object-cover rounded"
                            />
                        </div>

                        <div className="space-y-3">
                            <div>
                                <h3 className="font-semibold">Uses:</h3>
                                <p>{selectedProduct?.use ?? "N/A"}</p>
                            </div>

                            <div>
                                <h3 className="font-semibold">Details:</h3>
                                <p>{selectedProduct?.details ?? "N/A"}</p>
                            </div>

                            {/* <div>

                                <p className="text-blue-600 font-bold">
                                    {selectedProduct?.price || "Price not available"}
                                </p>
                            </div> */}
                        </div>

                        <div className="mt-6 flex justify-end">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <ProductsNavRow />
            <div className="container mx-auto px-4 py-2">
                <h1 className="text-3xl font-bold mb-3">
                    {accessories.name} Products
                </h1>

                {renderSubcategories()}
                {renderOptions()}
                {renderProducts()}
                {renderProductModal()}
            </div>
        </>
    );
};

export default ConstructionChemical;
